module.exports = __webpack_public_path__ + "img/SHFirmwareUpdate.6d927825.svg";